import React, { useRef, useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { state } from '../store/global';
import API from '../lib/api';
import { useNavigate } from 'react-router-dom';

import IconButton from '../components/common/IconButton';
import NormalButton from '../components/common/NormalButton';
import TextEntity from '../components/common/TextEntity';
import Tooltip from '../components/common/Tooltip';
import ComeBack from '../components/common/ComeBack';
import LockIcon from '../components/svg/LockIcon';
import PercentIcon from '../components/svg/PercentIcon';
import InfoIcon from '../components/svg/InfoIcon';
import EyeIcon from '../components/svg/EyeIcon';
import PlusIcon from '../assets/images/plus-white.svg';
import MinusIcon from '../assets/images/minus.svg';
import CustomModal from '../components/modal/CustomModal';

import SuccessIcon from '../components/svg/SuccessIcon';
import TableIcon from '../assets/images/table.svg';
import LoadingOverlay from '../components/common/LoadingOverlay';
import RewardsKaminoCard from '../components/RewardsKaminoCard';
import Achievements from '../components/Achievements';


export default function Rewards() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const rewardsHeader = [
    'Fecha',
    'Hora',
    'Movimiento',
    'Monto',
    'Estado'
  ];

  const [acceptedPolicy, setAcceptedPolicy] = useState(false);
  const [investProgress, setInvestProgress] = useState(0);
  const [deposite, setDeposite] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const filterRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [types, setTypes] = useState([false, false, false]);
  const [states, setStates] = useState([false, false]);
  const [dates, setDates] = useState(['', '']);
  const [rewards, setRewards] = useState([]);
  const [refundModel, setRefundModel] = useState(0);
  const [closeFlag, setCloseFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reward, setReward] = useState(null);
  const [investmentSummary, setInvestmentSummary] = useState({});
  const [err, setErr] = useState(null);
  const onInvest = async () => { };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [viewAll, setViewAll] = useState(false);


  const currentItems = rewards.filter(item => !viewAll ? item.status !== 'refunded' : true);

  const onSendDeposite = async (e) => {
    console.log(snap.user)
    setIsLoading(true);
   if(deposite >= 10 && deposite <= 10000000) {
    const depositeData = {
      transaction_id: "",
      user_id: snap.user.id,
      status: !closeFlag ? "created" : "refund",
      amount: deposite,
      currency: "USDC"
    }

    await API.post('/rewards', depositeData)
      .then((res) => {
        console.log('Rewards is created: ', res);
        navigate('/dashboard');
      })
      .catch((err) => {
        console.log('Fail the : ', err);
        if (err.status == 401) navigate('/dashboard/rewards');
        if (err.status == 400) setErr(true);
      });
    }
    setIsLoading(false);
  };

  const onFilter = async () => {
    const query = [];

    if (searchKeyword) query.push(`keyword=${searchKeyword}`);

    const transactionStates = [];
    if (states[0]) transactionStates.push('COMPLETED');
    if (states[1]) transactionStates.push('FAILED');
    if (transactionStates.length)
      query.push(`states=${transactionStates.join(',')}`);

    if (dates[0]) query.push(`startDate=${dates[0]}`);
    if (dates[1]) query.push(`endDate=${dates[1]}`);

    setIsOpen(false);
  };

  const InvestProgress = (step) => {
    switch (step) {
      case 1:
        setInvestProgress(step);
        break;
      case 2:
        if (deposite) {
          console.log(deposite)
          setInvestProgress(step);
        }
        break;
      case 3:
        setInvestProgress(step);
      default:
        break;
    }
  }

  const getCurrnetRewards = async () => {
    try {
      const res = await API.get('/rewards');

      if (res.data.success === 'success') {
        console.log(res.data.data)
        setRewards(res.data.data);
      }

    } catch (err) {
      const msg = err?.response?.data?.message || err?.message;
      console.log(msg);
    }
  }

  const onRequestClosing = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const res = await API.post(`rewards/closeinvest/${reward._id}`);

    if (res.data.success === 'success') {

      const updatedReward = res.data.reward;
      const updateRewards = rewards.map(rd => rd._id !== updatedReward._id ? rd : updatedReward);

      setRewards(updateRewards);
      setIsLoading(false);
      setRefundModel(2);
    }
  }

  const formatNumberBR = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  const getUserInvestmentSummary = async () => {
    const res = await API.get(`/rewards/getUserInvestmentSummary/${snap.user.id}`);

    if(res.data.success == "success") {
      setInvestmentSummary(res.data.investmentSummary);
      console.log("summary: ", res.data.investmentSummary)
    }
  }

  useEffect(() => {
    getCurrnetRewards();
    getUserInvestmentSummary();
    setIsLoading(false);
  }, []);

  return (
    <>
      {!investProgress && (
        <div className="relative px-10 py-8 space-y-8">
          <div className="py-4 border-b-1 border-b-[#E9EAEB] sm:flex space-x-4 space-y-4 sm:space-y-0">
            <div className="w-full space-y-1">
              <p className="text-xl font-semibold text-[#181D27]">
                Recompensas
              </p>
              <p className="text-sm font-normal text-[#535862]">
                {!acceptedPolicy
                  ? '¿Quieres que tus dólares trabajen por ti? Puedes generar recompensas a través de diferentes fondos y protocolos DeFi que utiliza tus fondos para generar recompensas.'
                  : 'Utiliza diferentes fondos y protocolos DeFi que trabajarán con tus fondos para obtener recompensas.'}
              </p>
            </div>
            {acceptedPolicy && (
              <div className="flex items-center gap-6">
                <IconButton
                  disabled={false}
                  bgColor="min-w-42"
                  icon={MinusIcon}
                  text="Retirar saldo"
                  textColor="text-[#092F7B]"
                  onClick={() => {
                    setCloseFlag(true);
                    InvestProgress(1);
                  }}
                />
                <IconButton
                  disabled={false}
                  bgColor="bg-[#092F7B] min-w-42"
                  icon={PlusIcon}
                  text="Invertir saldo"
                  textColor="text-[#FDFDFD]"
                  onClick={() => InvestProgress(1)}
                />
              </div>
            )}
          </div>

          {/* Logros e inversiones */}
          <Achievements userEmail={snap.user?.email} />

          {!acceptedPolicy ? (
            <div className="bg-white rounded-[20px] border border-[#CDD9F0] p-6 space-y-4">
              <p className="text-xs text-[#414651] font-medium leading-[22px]">
                Nota legal
              </p>
              <p className="text-xs text-[#535862] font-normal leading-[20px]">
                Flowex Pay actúa únicamente como un intermediario para conectar
                a los usuarios con diferentes fondos y DeFi. Los activos
                digitales que destines serán transferidos y no podrás retirarlos
                de inmediato ni usarlos mientras estén generando rendimientos.
                Flowex Pay no gestiona ni controla los rendimientos generados
                por Kamino.
              </p>
              <p className="text-xs text-[#535862] font-normal leading-[20px]">
                Flowex Pay y los fondos internacionales no son entidades
                vigiladas por la Superintendencia Financiera de Colombia. Los
                productos y servicios ofrecidos no cuentan con las protecciones
                de entidades reguladas. Participa bajo tu propio riesgo.
              </p>
              <p className="text-xs text-[#535862] font-normal leading-[20px]">
                Al participar, aceptas nuestra Política de Privacidad, que
                detalla cómo tratamos tus datos personales de acuerdo con la Ley
                1581 de 2012.
              </p>
              <p className="text-xs text-[#414651] font-medium leading-[22px]">
                Antes de invertir recuerda que:
              </p>

              <div className="space-y-2">
                <div className="sm:px-6 space-y-2">
                  <div className="space-x-4 flex items-center">
                    <div className="w-10 min-w-10 h-10 bg-[#092F7B] rounded-full flex items-center justify-center">
                      <LockIcon size="w-6 h-6" color="white" />
                    </div>
                    <div className="py-2.5">
                      <p className="text-sm text-[#414651] font-medium leading-[22px]">
                        Tus fondos serán transferidos
                      </p>
                      <p className="text-sm text-[#535862] font-normal leading-[20px]">
                        No podrás retirarlos ni usarlos mientras estén generando
                        rendimientos.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="sm:px-6 space-y-2">
                  <div className="space-x-4 flex items-center">
                    <div className="w-10 min-w-10 h-10 bg-[#092F7B] rounded-full flex items-center justify-center">
                      <PercentIcon size="w-6 h-6" color="white" />
                    </div>
                    <div className="py-2.5">
                      <p className="text-sm text-[#414651] font-medium leading-[22px]">
                        Tasa variable
                      </p>
                      <p className="text-sm text-[#535862] font-normal leading-[20px]">
                        Las recompensas son variables y no están garantizadas.
                        Dependes del mercado.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p className="text-sm text-[#535862] font-normal leading-[20px]">
                  ¿Tenes alguna duda?{' '}
                  <a className="text-[#061F5B] font-medium">
                    Contacta a soporte
                  </a>
                </p>
                <div className="h-11 sm:h-9">
                  <button
                    onClick={() => setAcceptedPolicy(true)}
                    className="float-right mt-2 sm:mt-0 bg-[#092F7B] text-sm text-[#FDFDFD] px-6 py-2 rounded-[10px] cursor-pointer"
                  >
                    Aceptar y continuar
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="sm:flex space-y-3 sm:space-y-0 sm:gap-6">
                <div className="w-full min-w-[310px] sm:w-1/2 lg:w-1/3 bg-gradient-to-r from-[#7B99DB1A] to-[#FFFFFF] p-[1px] rounded-[20px]">
                  <div className="bg-white p-6 space-y-2 rounded-[20px]">
                    <div className="flex items-center space-x-2">
                      <p className="inline text-base text-[#414651] font-medium leading-[20px]">
                        Recompensas acumuladas
                      </p>
                      <div className="relative group">
                        <InfoIcon />
                        <Tooltip text="Las recompensas son variables y no están garantizadas. Dependes del mercado." />
                      </div>
                    </div>
                    <div className="bg-[#F9FAFB] border-1 border-[#CDD9F0] p-6 rounded-[10px] flex items-center justify-between">
                      <p className="text-lg text-[#0A0D12] font-semibold leading-[20px]">
                        + <span className="text-xl">$ { formatNumberBR(investmentSummary.totalRewards) } </span>
                        <span className="text-xs text-[#717680] font-medium">
                          USD
                        </span>
                      </p>
                      <span className="px-2 py-0.5 text-xs text-[#FDFDFD] font-medium leading-[20px] bg-[#7B99DB] rounded-[10px]">
                        {formatNumberBR(investmentSummary.latestRate)}%{' '}
                        <span className="text-[10px] font-normal">Anual</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="w-full min-w-[310px] sm:w-1/2 lg:w-1/3 bg-gradient-to-r from-[#7B99DB1A] to-[#FFFFFF] p-[1px] rounded-[20px]">
                  <div className="bg-white p-6 space-y-2 rounded-[20px]">
                    <div className="flex items-center space-x-2">
                      <p className="inline text-base text-[#414651] font-medium leading-[20px]">
                        Saldo invertido
                      </p>
                      <EyeIcon />
                    </div>
                    <div className="bg-[#F9FAFB] border-1 border-[#CDD9F0] p-6 rounded-[10px]">
                      <p className="text-lg text-[#0A0D12] font-semibold leading-[20px]">
                        + <span className="text-xl">$ { formatNumberBR(investmentSummary.totalBalance) }</span>{' '}
                        <span className="text-xs text-[#717680] font-medium">
                          USD
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Kamino DeFi yield — tasa on-chain en vivo */}
              <RewardsKaminoCard />

              <div className="bg-white rounded-[20px] px-4 py-6 space-y-8">
                <div className="space-x-8 flex items-center justify-between">
                  <p className='text-[16px] font-[600]'>Últimas recompensas</p>

                  <div className="px-4.5 py-3 space-x-3 flex items-center justify-center">
                    <button onClick={
                      () => {
                        viewAll ? setViewAll(false) : setViewAll(true)
                      }
                    } className=' float-light text-[14px] font-[500] text-[#092F7B] leading-[22px] font-semibold cursor-pointer'>
                      Ver todas
                    </button>
                  </div>
                </div>

                <div>
                  {currentItems.length == 0 && (
                    <div className="py-6 space-y-2 bg-[#FDFDFD] border-1 border-[#F5F5F5] rounded-[10px]">
                      <div className="flex items-center justify-center">
                        <div className="w-9 h-9 bg-[#E6EBF7] rounded-full flex items-center justify-center">
                          <img
                            src={TableIcon}
                            className="w-5 h-5 bg-[#E6EBF7] rounded-full flex items-center justify-center"
                          />
                        </div>
                      </div>
                      <p className="text-center text-sm font-medium text-[#535862]">
                        Todavía no tienes movimientos registrados
                      </p>
                      <p className="text-center text-sm font-normal text-[#717680]">
                        Aquí verás todas tus recargas, transferencias, conversiones y
                        recompensas una vez comiences a operar.
                      </p>
                    </div>
                  )}

                  {currentItems.length && (
                    <div className="relative overflow-x-auto border-1 border-[#E1E1E1] sm:rounded-lg">
                      <table className="w-full font-[poppins] text-sm text-left rtl:text-right text-[#535862]">
                        <thead className="border-b-1 border-b-[#E1E1E1]">
                          <tr>
                            {rewardsHeader.map((name, idx) => (
                              <th key={idx} scope="col" className="px-5 py-4.5">
                                <div className="flex items-center space-x-3">
                                  <p className="font-normal">{name}</p>
                                </div>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((item, idx) => {
                            return (
                              <tr key={idx} className="border-b-1 border-b-[#E1E1E1]">
                                <td className="p-5 min-w-30">
                                  <p className="text-sm text-[#252B37] leading-[20px]">
                                    {item.created_at.slice(0, 10).replace(/-/g, "/")}
                                  </p>
                                </td>
                                <td className="p-5">
                                  <p className="text-sm text-[#535862] leading-[20px]">
                                    {item.created_at.slice(11, 19)}
                                  </p>
                                </td>
                                <td className="p-2">
                                  <div className="min-w-75">
                                    <div className="flex items-center justify-between">
                                      <p className="text-xs text-[#535862]">
                                        <strong>Recompensa</strong>
                                      </p>
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <p className="text-xs text-[#535862]">
                                        De Flowex Pay
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td className="min-w-40 p-5">{`${item.amount < 0 ? '-' : '+'
                                  } $${Math.abs(item.amount).toFixed(2)} ${item.currency
                                  }`}</td>

                                <td
                                  className={`p-2`}
                                >
                                  <span className="badge d-flex align-items-center rounded-pill px-3 py-2 aprobado">
                                    {
                                      item.status === "approved" ? (
                                        <button
                                          className="flex items-center gap-1 px-2 py-1 rounded-[54px] text-xs leading-[20px] text-green-600 bg-green-100 cursor-pointer"
                                        >
                                          <span className="w-2 h-2 rounded-full bg-green-500"></span>
                                          Aprobado
                                        </button>
                                      ) : item.status === 'refund' || item.status === 'pending' ? (
                                        <button
                                          className="flex items-center gap-1 px-2 py-1 rounded-[54px] text-xs leading-[20px] bg-[#FEF9F2] text-[#F59E0B] cursor-pointer"
                                        >
                                          <span className="w-2 h-2 rounded-full bg-[#F59E0B]"></span>
                                          Cierre
                                        </button>
                                      ) : item.status === 'created' ? (
                                        <button
                                          className="flex items-center gap-1 px-2 py-1 rounded-[54px] text-xs leading-[20px] bg-yellow-100 text-yellow-600 cursor-pointer"
                                        >
                                          <span className="w-2 h-2 rounded-full bg-yellow-500"></span>
                                          Creada
                                        </button>
                                      ) : item.status === 'refunded' ? (
                                        <button
                                          className="flex items-center gap-1 px-2 py-1 rounded-[54px] text-xs leading-[20px] bg-[#F3F4F6] text-[#6B7280] cursor-pointer"
                                        >
                                          <span className="w-2 h-2 rounded-full bg-[#6B7280]"></span>
                                          Reintegrada
                                        </button>
                                      ) : item.status === 'rejected' ? (
                                        <button
                                          className="flex items-center gap-1 px-2 py-1 rounded-[54px] text-xs leading-[20px] bg-[#FEF3F2] text-[#F04438] cursor-pointer"
                                        >
                                          <span className="w-2 h-2 rounded-full bg-[#F04438]"></span>
                                          Rechazado
                                        </button>
                                      ) : item.status === 'actived' ? (
                                        <button
                                          className="flex items-center gap-1 px-2 py-1 rounded-[54px] text-xs leading-[20px] bg-[#E6EBF7] text-[#2A59C6] cursor-pointer"
                                          onClick={() => {
                                            setRefundModel(true);
                                            setReward(item);
                                          }}
                                        >
                                          <span className="w-2 h-2 rounded-full  bg-[#2A59C6]" ></span>
                                          En proceso
                                        </button>
                                      ) : ""
                                    }
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {investProgress == 1 && (
        <div className="relative py-8 flex items-center justify-center">
          <div className="w-153.5 bg-white border border-[#E6EBF7] rounded-[20px] p-6 space-y-6">
            <div className="space-y-2">
              <ComeBack
                text={!closeFlag ? "Invertir saldo" : "Retirar saldo"}
                onClick={() => InvestProgress(0)}
              />

            </div>

            <div className="space-y-1 text-[#414651]">
              <p className="text-sm font-normal leading-[20px]">
                {!closeFlag ? "Saldo a invertir" : "Saldo a retirar"}
              </p>
              <div className="relative">
                <label className="absolute top-[9px] left-3 text-sm text-[#A4A7AE] font-normal leading-[20px]">
                  $
                </label>
                <input
                  type="text"
                  className="w-full pl-6 py-2 bg-[#F9FAFB] text-sm leading-[20px] border border-[#A4A7AE] rounded-[10px]"
                  placeholder="0.00"
                  name="deposite"
                  value={deposite}
                  onChange={(e) => setDeposite(e.target.value)}
                />
              </div>
	      <p
                className={`text-xs font-normal leading-[20px] ${
                  deposite >= 10 && deposite <= 1000000 ? "text-green-500" : "text-red-500"
                }`}
              >
                Mínimo $10,00 Máximo $1.000.000
              </p>
            </div>

            <div className="border-b-1 border-b-[#E9EAEB]" />

            <div className="flex items-center justify-between">
              <span className="flex items-center space-x-1">
                <p className="text-base text-[#717680] font-medium leading-[20px]">
                  Tasa actual
                </p>
                <InfoIcon size="w-5 h-5" />
              </span>
              <p className="text-base text-[#535862] font-normal leading-[20px]">
                {formatNumberBR(investmentSummary.latestRate)}%
              </p>
            </div>
            <button
              onClick={() => deposite >= 10 && deposite <= 10000000 ? InvestProgress(2) : ''}
              className="float-right px-6 py-2 bg-[#092F7B] text-white rounded-[10px] cursor-pointer"
            >
              Continuar
            </button>
          </div>
        </div>
      )}

      {investProgress == 2 && (
        <div className="relative py-8 flex items-center justify-center">
          <div className="w-153.5 bg-white border border-[#E6EBF7] rounded-[20px] p-6 space-y-6">
            <div className="space-y-2">
              <ComeBack
                text="Confirmación"
                onClick={() => InvestProgress(1)}
              />
              <p className="text-sm text-[#535862] font-normal leading-[20px]">
                Confirma los siguientes datos para concretar la operación
              </p>
            </div>

            <div className="w-full bg-gradient-to-r from-[#FFFFFF] to-[#E7EFFF] py-2 rounded-[10px]">
              <div className="h-[29px] flex items-center justify-center space-x-1">
                <p className="inline text-sm text-[#092F7B] font-medium leading-[22px]">
                  {closeFlag ? "Saldo a retirar de recompensas" : "Monto a invertir en recompensas"}
                </p>
                <InfoIcon color="#092F7B" />
              </div>
              <p className="text-xl text-[#181D27] font-semibold text-center py-1">
                ${deposite} USD
              </p>
            </div>

            <span className="float-right">
              <div className="space-x-2.5">
                <NormalButton
                  customClass="text-[#092F7B] bg-white"
                  text="Cancelar"
                  onClick={() => console.log('sd')}
                />
                <NormalButton
                  customClass="text-[#FDFDFD] bg-[#092F7B]"
                  text="Confirmar"
                  onClick={() => InvestProgress(3)}
                />
              </div>
            </span>
          </div>
        </div>
      )}

      {investProgress == 3 && (
        <div className="relative py-8 flex items-center justify-center">
          <div className="w-153.5 bg-white border border-[#E6EBF7] rounded-[20px] p-6">
            <div className="space-y-2 mb-3">
              <ComeBack
                text="Comprobante de operación"
                onClick={() => InvestProgress(2)}
              />
            </div>

            <div className="space-y-4 mb-6">
              <div className="px-4 py-2 space-y-2 bg-[#FDFDFD] border border-[#E6EBF7] rounded-[10px]">
                <p className="text-sm text-[#092F7B] font-medium leading-[22px]">
                  {closeFlag ? "Retiraste" : "Invertiste"}
                </p>
                <p className="text-xl text-[#181D27] font-semibold">
                  ${deposite} USD
                </p>
              </div>

              <div className="px-4 space-y-4">
                <TextEntity
                  title="Tipo de transacción"
                  content={closeFlag ? "Retiro de inversión fondos DeFi" : "Inversión fondos DeFi"}
                />
                <TextEntity title="Fecha y hora" content="01/02/2025 - 15:05" />
                <TextEntity title="Cuenta" content="Flowex Pay 1234566" />
                <TextEntity title="Referencia" content="908123ABC4567" />
              </div>
              {err ? <p
                className={`text-xs font-normal leading-[20px] text-red-500`}
              >
               El dinero en su bóveda es insuficiente.
              </p> : ''}
            </div>

            <span className="inline float-right">
              <NormalButton
                customClass="text-[#092F7B] bg-white"
                text="Volver al inicio"
                onClick={() => console.log('sd')}
              />
              <NormalButton
                customClass="text-[#FDFDFD] bg-[#092F7B]"
                text="Descargar comprobante"
                onClick={() => onSendDeposite()}
              />
            </span>
          </div>
        </div>
      )}

      {refundModel > 0 && (
        <CustomModal>
          {
            refundModel == 1 && (
              <div className="space-y-4 w-95 bg-white px-6 pt-8 pb-4 rounded-[20px] border border-[#E6EBF7]">
                <p className="text-xl text-[#333333] font-semibold leading-[20px] text-center">
                  Reembolsar la inversión
                </p>
                <p className="text-[#717680] leading-[22px] text-center">
                  ¿Quieres recuperar tu inversión?
                </p>
                <div className="space-y-2">
                  <NormalButton
                    customClass="w-full bg-[#092F7B] text-[#FDFDFD]"
                    text="Reembolso"
                    onClick={onRequestClosing}
                  />
                  <NormalButton
                    customClass="w-full bg-[#FDFDFD] text-[#092F7B] border border-[#092F7B]"
                    text="Cancelar"
                    onClick={() => setRefundModel(false)}
                  />
                </div>
              </div>
            )
          }

          {refundModel == 2 && (
            <div className="space-y-4 w-95 bg-white p-6 rounded-[20px]">
              <div className="space-y-2">
                <div className="flex items-center justify-center">
                  <div className="w-10 h-10 bg-[#D1FADF] rounded-full flex items-center justify-center">
                    <SuccessIcon size={24} color="#05603A" />
                  </div>
                </div>
                <p className="text-xl text-[#333333] font-semibold leading-[20px] text-center">
                  Solicitud exitosa
                </p>
                <p className="text-[#717680] leading-[22px]">
                  Se solicitó con éxito el cierre de la inversión.
                </p>
              </div>
              <NormalButton
                customClass="w-full bg-[#092F7B] text-[#FDFDFD]"
                text="Aceptar"
                onClick={() => setRefundModel(0)}
              />
            </div>
          )}
        </CustomModal>
      )}
      {
        isLoading ? <LoadingOverlay /> : ""
      }
    </>


  );
}
